import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cMsgList from './cMsgList';

export default class iMsgList extends cMsgList {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  render() {
    return ( //  子で上書き
      <ce.RootDtl
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iMsgSet',
            sgc_pagePntKey: '',
            sgc_pageKey: '',
            sgc_pageMode: 'new',
            sgc_pagePrc: '',
            sgcb_pageEdt: true,
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('メッセージグループ一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_ct21ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iMsgDtl',
//              nextPage: 'iMsgSet',
              pagePntKeyName: 'ct21_key', // sgcd_pagePntKeys へ反映するために必要
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }

};
